module.exports = __webpack_public_path__ + "static/media/setting-colorful.b9a2eea8.png";